export default "__VITE_ASSET__BAE2c2Ic__"